<template>
<div>
  <create-long v-if="showLong === true"></create-long>
  <create-short v-if="showLong === false" :can-accept="canAccept"></create-short>
  <b-modal size="md" v-model="showDialog" centered title="Wie wollen Sie die Aufgabe erfassen ?"
           :no-close-on-backdrop="true"
           :no-close-on-esc="true"
  >
    <b-row class="mt-2">
      <b-col>
        <b-form-group>
          <b-form-radio v-model="selection" name="some-radios" value="long">Erweiterte Erfassung</b-form-radio>
          <b-form-radio v-model="selection" name="some-radios" value="short">Kurzerfassung</b-form-radio>
        </b-form-group>
      </b-col>
    </b-row>
    <template #modal-footer="{ok, cancel}">
      <b-button size="md" variant="success" @click="onSelected">
        OK
      </b-button>
    </template>
  </b-modal>
</div>
</template>

<script>
import CreateLong from "@/views/auftraege/create/test.vue"
import CreateShort from "@/views/auftraege/create/AndroidCreateShort.vue"
import {Redirect_500, Redirect_Login, Server_URL} from "@/shared/utils";

export default {
  name: "AndroidRouter",
  components: {
    CreateLong,
    CreateShort
  },
  data() {
    return {
      showLong: null,
      showDialog: false,
      selection: 'long',
      loader: undefined,
      canAccept: false,
    }
  },
  mounted() {
    this.showLoader();
    this.$http.get(
        Server_URL + '/auftragsbuch/data/av/can_accept'
    ).then(this.handleDataOk, this.responseError)
  },
  methods: {
    onSelected() {
      this.showDialog = false
      if (this.selection === "long") {
        this.showLong = true;
      } else {
        this.showLong = false;
      }
    },
    handleDataOk(response) {
      this.hideLoader();
      if (response.status === 200) {
        if (response.body.canCreateLong === true) {
          this.canAccept = true;
          this.showDialog = true;
        } else {
          this.showLong = false;
        }
      } else {
        window.location = Redirect_500;
      }
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_Login;
      }
    },
    showLoader() {
      this.hideLoader();
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
  }
}
</script>

<style scoped>

</style>
